import { ConsentManager } from '@oneaudi/audi-cookie-service';
export function createFallbackConsentManager(logger) {
    logger.warn('CookieService is using Fallback consent manager and will a return a negative consent by default');
    const getConsent = () => {
        return {
            essential: false,
            functional: false,
            marketing: false,
            performance: false,
        };
    };
    return new ConsentManager(getConsent);
}
//# sourceMappingURL=fallback-consent-manager.js.map